import styled from 'astroturf/react'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { usePageTitle } from '@calendly/hooks'
import { useFlag } from '@calendly/feature-check-react'

import { useI18n } from 'locales'
import { loadingProgressSelector } from 'selectors'
import { calendarDaysByWeekSelector } from 'selectors/calendars'
import Footer from 'components/select_date_time/footer'
import ProgressBar from 'components/select_date_time/spotpicker/progress_bar'
import { useMutualAvailabilityEnabled } from 'components/mutual_availability/use_mutual_availability_enabled'
import { Navigator } from 'components/select_date_time/spotpicker/navigator'

import Header from './header'
import Weeks from './weeks'
import InviteeEventsList from './invitee_events_list'
import _Wrapper from "index-Wrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/index.js?styleId=Wrapper";
import _Row from "index-Row.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/index.js?styleId=Row";
import _StyledNavigator from "index-StyledNavigator.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/index.js?styleId=StyledNavigator";


const Wrapper = /*#__PURE__*/styled('div', null, {
  displayName: "Wrapper",
  styles: _Wrapper,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown'),
    isDesktopUp: useDeviceType('isDesktopUp'),
    isPhone: useDeviceType('isPhone')
  })
})

const Row = /*#__PURE__*/styled('div', null, {
  displayName: "Row",
  styles: _Row,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const StyledNavigator = /*#__PURE__*/styled(Navigator, null, {
  displayName: "StyledNavigator",
  styles: _StyledNavigator
})

const SpotPicker = () => {
  const daysByWeek = useSelector(calendarDaysByWeekSelector)

  return (
    <>
      <Header />
      <Row>
        <Weeks daysByWeek={daysByWeek} />
      </Row>
    </>
  )
}

const MobileView = () => {
  const [currentTab, setCurrentTab] = useState('time')
  return (
    <>
      <StyledNavigator currentTab={currentTab} setCurrentTab={setCurrentTab} showPollLabel />
      {currentTab === 'time' ? <SpotPicker /> : <InviteeEventsList />}
    </>
  )
}

const FlatSpotpicker = () => {
  const { i18n } = useI18n()
  const loadingProgress = useSelector(loadingProgressSelector)
  const isPhone = useDeviceType('isPhone')
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const isMutualAvailabilityEnabled = useMutualAvailabilityEnabled()

  usePageTitle(`${i18n.t('booking.templates.poll.select_available_times')} - Calendly`)

  return (
    <Wrapper
      data-component="flat-spotpicker"
      bookingAppRedesign={bookingAppRedesign}
    >
      <ProgressBar loadingProgress={loadingProgress} calendarActive />
      {isMutualAvailabilityEnabled && isPhone ? <MobileView /> : <SpotPicker />}
      <Footer />
    </Wrapper>
  )
}

export default FlatSpotpicker
